import { Experiment, ExperimentClient } from '@amplitude/experiment-js-client'

let experimentClient: ExperimentClient | null = null

export function getExperimentClient() {
  if (!experimentClient) {
    experimentClient = Experiment.initializeWithAmplitudeAnalytics(
      'client-YVhDftmJsD0AbyN2rA2X8mz8v43pa7uQ',
    )
    experimentClient.start()
  }
  return experimentClient
}
